exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.reportZ-btn[data-v-b1abdedc] {\n  width: 210px;\n  height: 36px;\n  border-radius: 4px;\n  background-color: #000000;\n  border: solid 0.5px #e5e5e5;\n}\n.logOut-btn[data-v-b1abdedc] {\n  width: 210px;\n  height: 36px;\n  border-radius: 4px;\n  background-color: #ffffff;\n  border: solid 1px #000000;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b1abdedc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/user-info/UserInfo.vue
// module id = 503
// module chunks = 1